import { bool, number, shape, string } from 'prop-types'

export const subscriptionPlanShape = shape({
  monthlyPrice: number.isRequired,
  generationsPerMonth: number,
  annualFreeMonths: number,
  catalogValue: string,
  isUpgrade: bool,
})
